/* RESPONSIBLE TEAM: team-proactive-support */
import Model, { attr } from '@ember-data/model';
import { fragmentArray } from 'ember-data-model-fragments/attributes';

export default class TranslationSettings extends Model {
  @attr('string') defaultTranslationLocaleId;
  @attr('array') translationLocaleIds;
  @fragmentArray('outbound-subscriptions/locale', { async: false }) possibleLocales;
}
